<div class="container-fluid">
  <div class="alert alert-danger m-2 rounded" role="alert">
    <div class="ml-2">{{'page-not-found' | translate}}</div>
  </div>
</div>
